<div class="row">
  <div class="card shadow-none rounded">
    <div class="card-body">
      <div class="col-12 col-md-12 col-xxl-12 col-xl-12">
        <div class="row">
          <div class="col-12 col-xxl-10 col-xl-10 col-md-10 col-lg-10 col-sm-10">
            <h4 class="fw-bold">Revaluation reserve - {{commonService.headerName}}</h4>
          </div>
          <div class="col-12 col-xxl-2 col-xl-2 col-md-2 col-lg-2 col-sm-2 text-start text-sm-end p-sm-0 pt-2">
            <button type="button" class="btn btn-outline-themecolorlight" style="padding: 7px;font-weight: 600; font-size: 14px;" tabindex="-1" (click)="TotalBack()">Close Accounts</button>
          </div>
        </div>
      </div>
      <hr />
      <form [formGroup]="reserveform">
        <div class="col-12 col-md-12 col-xxl-12 col-xl-12 col-lg-12  col-sm-12">
          <div class="row">
            <div class="col-12 col-xxl-12 col-xl-12 col-md-12 col-lg-12 col-sm-12">
              <!--<h5 class="fw-bolder font-size-16">Revaluation reserve</h5>-->
              <div class="mb-3">
                <p class="mt-4">Please enter notes on revaluation reserve  in the field below.</p>
                <p>If you do not have any notes to make, please return to the notes menu and de-select this section.</p>
              </div>
              <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <div class="row mt-4">
                  <div class="row">
                    <div class="col-12">
                      <div class="form-group">
                        <div class="row">
                          <div class="col-xxl-4 col-xl-4 col-md-12 col-lg-12 col-sm-12 col-12">
                            <label class="m-t-5 font-weight-600"></label>
                          </div>
                          <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                            <div class="row">
                              <div [ngClass]="commonService.showControl? 'col-xxl-8 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6':'col-xxl-9 col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12'">
                                <div class="mb-2 text-center">
                                  <h6 class="mb-0 fw-bolder"> {{commonService.StartYear}}</h6>
                                  <label>({{commonService.CAPeriodFrom}} to {{commonService.CAPeriodTo}})</label>
                                </div>
                              </div>
                              <!--<div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" *ngIf="commonService.showControl==true">
    <div class="mb-2 text-center">
      <h6 class="mb-0 fw-bolder"> {{commonService.LastYear}}</h6>
      <label>({{commonService.LYAccountingPeriod}} to {{commonService.StartdateLastAP}})</label>
    </div>
  </div>-->
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 ps-0 ps-lg-5">
                  <div class="form-group">
                    <div class="row">
                      <div class="col-xxl-4 col-xl-4 col-md-12 col-lg-12 col-sm-12 col-12">
                        <label class="m-t-5 font-weight-600">At {{commonService.StartDate}}</label>
                      </div>
                      <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="row">
                          <div [ngClass]="commonService.showControl? 'col-xxl-8 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6':'col-xxl-9 col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12'">
                            <div class="input-group mb-3">
                              <div class="input-group-text">
                                <span class=" theme-color font-weight-600">£</span>
                              </div>
                              <input type="text" class="form-control AccountNumber text-end" [appTooltip]="showBubbledata" appNumberdirective formControlName="RevaluationReserveGrossStart" placeholder="" maxlength="11" (blur)="calculations()" />
                            </div>
                          </div>
                          <!--<div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" *ngIf="commonService.showControl==true">
    <div class="input-group mb-3">
      <div class="input-group-text">
        <span class=" theme-color font-weight-600">£</span>
      </div>
      <input type="text" class="form-control AccountNumber text-end" appNumberdirective formControlName="GrossStart_LY" placeholder="" maxlength="11" (blur)="calculationsLY()"/>
    </div>
  </div>-->
                        </div>
                      </div>
                    </div>
                  </div>
                      <div class="form-group">
                        <div class="row">
                          <div class="col-xxl-4 col-xl-4 col-md-12 col-lg-12 col-sm-12 col-12">
                            <label class="m-t-5 font-weight-600">Surplus or deficit arising from revaluation</label>
                          </div>
                          <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                            <div class="row">
                              <div [ngClass]="commonService.showControl? 'col-xxl-8 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6':'col-xxl-9 col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12'">
                                <div class="input-group mb-3">
                                  <div class="input-group-text">
                                    <span class=" theme-color font-weight-600">£</span>
                                  </div>
                                  <input type="text" class="form-control AccountNumber text-end" [appTooltip]="showBubbledata" appNumberdirective formControlName="SurplusOrDeficitArisingFromRevaluation" placeholder="" maxlength="11" (blur)="calculations()" />
                                </div>
                              </div>
                              <!--<div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" *ngIf="commonService.showControl==true">
    <div class="input-group mb-3">
      <div class="input-group-text">
        <span class=" theme-color font-weight-600">£</span>
      </div>
      <input type="text" class="form-control AccountNumber text-end" appNumberdirective formControlName="SurplusOrDeficitArisingFromRevaluation_LY" placeholder="" maxlength="11" (blur)="calculationsLY()" />
    </div>
  </div>-->
                            </div>
                          </div>
                        </div>
                      </div>
                          <div class="form-group">
                            <div class="row">
                              <div class="col-xxl-4 col-xl-4 col-md-12 col-lg-12 col-sm-12 col-12">
                                <label class="m-t-5 font-weight-600">At {{commonService.EndDate}}</label>
                              </div>
                              <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                                <div class="row">
                                  <div [ngClass]="commonService.showControl? 'col-xxl-8 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6':'col-xxl-9 col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12'">
                                    <div class="input-group mb-3">
                                      <div class="input-group-text">
                                        <span class=" theme-color font-weight-600">£</span>
                                      </div>
                                      <input type="text" class="form-control  text-end" formControlName="GrossEnd" placeholder="" value="0" maxlength="11"  (blur)="calculations()" />
                                    </div>
                                  </div>
                                  <!--<div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" *ngIf="commonService.showControl==true">
    <div class="input-group mb-3">
      <div class="input-group-text">
        <span class=" theme-color font-weight-600">£</span>
      </div>
      <input type="text" class="form-control text-end" formControlName="GrossEnd_LY" placeholder="" value="0" maxlength="11" readonly (blur)="calculationsLY()"/>
    </div>
  </div>-->
                                </div>
                              </div>
                            </div>
                     </div>
                  </div>
              </div>
                  <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-3">
                    <label>Please enter any additional information in the field below.</label>
                    <div class="mb-3">
                      <textarea class="form-control txt-area allowSpecialChars" [appTooltip]="showBubbledata" appNumberdirective rows="5" formControlName="RevaluationReserveAdditionalInformation" maxlength="4000"></textarea>
                    </div>
                  </div>
                  </div>
              </div>
            </div>
            <div class="col-12 col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 text-end mt-4 pe-0">
              <button type="button" class="btn btn-outline-back p-1 ps-3 pe-3 me-2" (click)="back()">Back</button>
              <button type="button" class="btn themedefault p-1 ps-3 pe-3 ms-1 me-0" (click)="save()">Next</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
